const comment_old = { block: "comment_old", getAttrs: (tok) => tok.attrs };

export default comment_old;
